module.exports = __webpack_public_path__ + "img/lome2.e39372ee.jpeg";